import { DealerFilterData, DealerFilterTypes } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { Button, /* CalendarField, */ SearchField } from '@components';
import { useAppDispatch, useAppSelector } from '@hooks';
import { Clear } from '@mui/icons-material';
import { Box, Stack } from '@mui/material';
import { getTableBlockData, setFilters, setOffset } from '@store/table/table.slice';
import { t } from '@translations';
import { useEffect, useState } from 'react';
import { useDebounce } from 'usehooks-ts';

export const DealerListSearch = ({ id }: { id: string }) => {
  const dispatch = useAppDispatch();
  const { filters, visibleFilters } = useAppSelector(getTableBlockData(id));
  const [localFilters, setLocalFilters] = useState(filters as DealerFilterData);
  const debouncedFilters = useDebounce(localFilters, 500);

  const isFilterVisible = (filterName: DealerFilterTypes) => visibleFilters.includes(filterName);

  const updateFilters = (field: keyof DealerFilterData, value: any) => {
    setLocalFilters({ ...(filters as DealerFilterData), [field]: value });
  };

  const clearFilters = () => {
    let newFilters = { ...(filters as DealerFilterData) };
    for (let filter of visibleFilters) {
      newFilters[filter as keyof DealerFilterData] = undefined;
    }
    setLocalFilters({ ...newFilters });
    dispatch(setOffset({ id, offset: 0 }));
  };

  useEffect(() => {
    dispatch(setFilters({ id, filters: debouncedFilters }));
  }, [debouncedFilters, dispatch, id, localFilters]);

  useEffect(() => {
    setLocalFilters(filters as DealerFilterData);
  }, [filters]);

  return (
    <Box sx={{ mb: 4 }}>
      <Stack direction={{ xs: 'column', lg: 'row' }} spacing={{ xs: 4, lg: 2 }}>
        {isFilterVisible('Search') && (
          <SearchField
            label={t(TextCodes.Customer.Block.Search)}
            name='filter'
            value={localFilters?.Search || ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              updateFilters('Search', e.target.value)
            }
            sx={{ width: '100%' }}
            placeholder={t(TextCodes.Customer.Block.SearchDealerPlaceholder)}
          />
        )}
        {/* 
        TODO [MB] uncomment if filter via last order date will be ready to use
        {isFilterVisible('LastOrderDate') && (
          <CalendarField
            value={localFilters?.LastOrderDate || ''}
            onChange={(e: any) => {
              updateFilters('LastOrderDate', e);
            }}
            sx={{ minWidth: '239px' }}
            label={t(TextCodes.Customer.Block.LastOrderDate)}
          />
        )} */}
        <Button variant='tertiary' onClick={() => clearFilters()} startIcon={<Clear />}>
          {t(TextCodes.Customer.Block.Clear)}
        </Button>
      </Stack>
    </Box>
  );
};
